module.exports = __webpack_public_path__ + "static/media/write2raise-logo.bc98e5d6.svg";